export const environment = {
  production: true,
  client: 'algocyte',
  OcpApimSubscriptionKey: 'c404897dfbff47d99b74cd8c5c4d6a35',
  oia0TenantConfig: {
    baseUrl: 'https://oia0.b2clogin.com/',
    tenant: 'oia0.onmicrosoft.com',
    clientID: '416f63e7-d97b-40c9-b56b-44c7c3d5d842',
    signInPolicy: 'B2C_1_SISU',
    signUpPolicy: 'B2C_1_SISU',
    resetPAsswordPolicy: 'B2C_1_PRES',
    editPolicy: 'B2C_1_EP',
    b2cScopes: ['https://oia0.onmicrosoft.com/api/Hello.Read'],
  },
  oiaUatTenantConfig: {
    baseUrl: 'https://oiauat.b2clogin.com/',
    tenant: 'oiauat.onmicrosoft.com',
    clientID: '33e7cea7-de8f-4e4e-94e8-7e617099724a',
    signInPolicy: 'B2C_1_uatsigninsignup',
    signUpPolicy: 'B2C_1_uatsigninsignup',
    resetPAsswordPolicy: 'B2C_1_uatpassword',
    editPolicy: 'B2C_1_EP',
    b2cScopes: ['https://oiauat.onmicrosoft.com/api/demo.read'],
  },
  textMessage: 'For evaluation purposes only, Formative Usability Evaluation',
  demoMessage: 'Demo system - internal use only',
  feedbackMessage: 'Send feedback to ',
  feedbackMail: 'feedback@algocyte.com',
  environment: 'staging',
  firebaseConfig: {
    apiKey: 'AIzaSyBh8FHxvD6I5ZoLVUVmDcYyfW1BXwbFr8Q',
    authDomain: 'oia-35f5b1537c07afdf-stage.firebaseapp.com',
    projectId: 'oia-35f5b1537c07afdf-stage',
    storageBucket: 'oia-35f5b1537c07afdf-stage.appspot.com',
    messagingSenderId: '74687918068',
    appId: '1:74687918068:web:27df548106bb4a3b4593a1',
  },
  baseUrl: 'https://oia-35f5b1537c07afdf-stage.nw.r.appspot.com',
  cookieYesAppId: '7da2757c75ff2275b4bbded7',
  enableTestHelper: true,
  maintenanceMode: false,
  surveyJsApiKey: 'ZTg3ODBlOWEtNmM1My00MDYzLWEyY2MtMDBjZTkzYjVkMjMxOzE9MjAyNC0wOC0wNw==',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
